import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { removeToolTip } from 'src/app/_helpers/Utils'
import { ViewValidation } from 'src/app/_helpers/ViewValidation'
import { Section } from 'src/app/models/HandlerOperation'
import { HandlerOperationService } from 'src/app/services/handler.operation.service'
import { NotificationService } from 'src/app/services/notification.service'

@Component({
	selector: 'app-section',
	templateUrl: './section.component.html'
})
export class SectionComponent implements OnInit {

		@Input() public section: Section = new Section()
		@Input() public handlerOperationId: string = ''

		@Output() public close: EventEmitter<any> = new EventEmitter()
		@Output() public sectionForNewManagment: EventEmitter<Section> = new EventEmitter()
		@Output() public getSections: EventEmitter<any> = new EventEmitter()

		public ViewValidation: ViewValidation = new ViewValidation()
		public handleSectionInNewManagement: boolean = false

		constructor(
				public notificationService: NotificationService,
				private operationService: HandlerOperationService
		) {}

		public ngOnInit(): void {
				if (!this.section.id) {
						this.section.handlerOperationId = this.handlerOperationId
				}

				this.handleSectionInNewManagement = !Boolean(this.handlerOperationId)
		}

		public async addNewSection() {
				if (this.handleSectionInNewManagement) {
						const {
								name,
								description
						} = this.section

						const id =  Math.floor(Math.random() * (100 + 1))

						this.sectionForNewManagment.emit({
								id,
								name,
								description
						})
						this.close.emit()

						return
				}

				this.notificationService.initLoading()

				try {
						const response =
								await this.operationService.createSection(this.section).toPromise()

						this.notificationService.notify(response, 200)
						this.close.emit()
						this.getSections.emit()
				} catch (error) {
						this.notificationService.notify(error.error.message || 'Erro ao criar o inciso', 400)
				}
		}

		public async editSection() {
				if (this.handleSectionInNewManagement) {
						this.sectionForNewManagment.emit(this.section)
						this.close.emit()

						return
				}

				this.notificationService.initLoading()

				try {
						const response =
								await this.operationService.editSection(this.section).toPromise()

						this.notificationService.notify(response, 200)
						this.close.emit()
						this.getSections.emit()
				} catch (error) {
						this.notificationService.notify(error.error.message || 'Erro ao atualizar o inciso', 400)
				}
		}

		public closeSection() {
				this.close.emit()
				removeToolTip()
		}
}
